import type { Action } from 'src/types';
import type * as Schema from 'src/types/graphql';

export enum Actions {
  UPDATE_CAREER_HISTORY_START = 'UPDATE_CAREER_HISTORY_START',
  UPDATE_CAREER_HISTORY_SUCCESS = 'UPDATE_CAREER_HISTORY_SUCCESS',
  UPDATE_CAREER_HISTORY_FAILURE = 'UPDATE_CAREER_HISTORY_FAILURE',

  DELETE_CAREER_HISTORY_START = 'DELETE_CAREER_HISTORY_START',
  DELETE_CAREER_HISTORY_SUCCESS = 'DELETE_CAREER_HISTORY_SUCCESS',
  DELETE_CAREER_HISTORY_FAILURE = 'DELETE_CAREER_HISTORY_FAILURE',

  ADD_UNCONFIRMED_ROLE_START = 'ADD_UNCONFIRMED_ROLE_START',
  ADD_UNCONFIRMED_ROLE_SUCCESS = 'ADD_UNCONFIRMED_ROLE_SUCCESS',
  ADD_UNCONFIRMED_ROLE_FAILURE = 'ADD_UNCONFIRMED_ROLE_FAILURE',

  REJECT_UNCONFIRMED_ROLE_START = 'REJECT_UNCONFIRMED_ROLE_START',
  REJECT_UNCONFIRMED_ROLE_SUCCESS = 'REJECT_UNCONFIRMED_ROLE_SUCCESS',
  REJECT_UNCONFIRMED_ROLE_FAILURE = 'REJECT_UNCONFIRMED_ROLE_FAILURE',

  FETCH_CONFIRMED_ROLES_SUCCESS = 'FETCH_CONFIRMED_ROLES_SUCCESS',
  FETCH_UNCONFIRMED_ROLES_SUCCESS = 'FETCH_UNCONFIRMED_ROLES_SUCCESS',
}

export type CareerHistoryAction =
  | (Action<Actions.UPDATE_CAREER_HISTORY_START> & {
      payload: Omit<Schema.UpdateRoleInput, 'function' | 'industry'>;
    })
  | Action<Actions.UPDATE_CAREER_HISTORY_SUCCESS>
  | (Action<Actions.UPDATE_CAREER_HISTORY_FAILURE> & {
      payload: Error;
    })
  | (Action<Actions.ADD_UNCONFIRMED_ROLE_START> & {
      payload: { id: string };
    })
  | Action<Actions.ADD_UNCONFIRMED_ROLE_SUCCESS>
  | (Action<Actions.ADD_UNCONFIRMED_ROLE_FAILURE> & {
      payload: Error;
    })
  | (Action<Actions.REJECT_UNCONFIRMED_ROLE_START> & {
      payload: Schema.RejectUnconfirmedDataInput;
    })
  | Action<Actions.REJECT_UNCONFIRMED_ROLE_SUCCESS>
  | (Action<Actions.REJECT_UNCONFIRMED_ROLE_FAILURE> & {
      payload: Error;
    })
  | Action<Actions.DELETE_CAREER_HISTORY_START>
  | Action<Actions.DELETE_CAREER_HISTORY_SUCCESS>
  | (Action<Actions.DELETE_CAREER_HISTORY_FAILURE> & {
      payload: Error;
    });
